import React from "react";
import { Page } from "@shopify/polaris";

export function MockupJobsPage() {
    return <Page title="All Mockup Jobs" fullWidth></Page>;
}
